<template>
    <div class="service-box">
        <div class="head-box"><navBar></navBar></div>
        <div class="content">
            <!-- 加入上上参谋官方服务商s -->
            <div class="banner-box" v-img="{ form: form.bannerObj, key: 'img' }" :style="'background-image: url(' + form.bannerObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="text-content wow fadeInUp">
                        <p class="name pingFang-Bold font50" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                        <p class="tip-text font26" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</p>
                        <!-- <router-link
                            :to="!$store.state.token ? form.bannerObj.path : { path: $route.fullPath }"
                            class="but but-blank but-blank-hover understand-details"
                            type="primary"
                            round
                            v-edit="{ form: form.bannerObj, key: 'buttonContent' }"
                        >
                            {{ form.bannerObj.buttonContent }}&nbsp;
                            <span class="arrow el-icon-d-arrow-right"></span>
                        </router-link> -->
                    </div>
                </div>
            </div>
            <!-- 加入上上参谋官方服务商e -->
            <!-- 海量开店用户聚集s -->
            <div class=" number-show-box">
                <div class="container1">
                    <div class="wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</p>
                        <p class="tips font24" v-edit="{ form: form.firstObj, key: 'content' }">{{ form.firstObj.content }}</p>
                    </div>
                    <div class="number-show-content wow fadeInUp">
                        <div class="number-show-cell" v-for="(item, key) in form.firstObj.list" :key="key">
                            <div class="text-line text-overflow">
                                <div class="number text-overflow beatingNumber-box">
                                    <div class="beatingNumber" v-edit="{ form: item, key: 'name' }">{{ item.name }}</div>
                                    <span class="unit" v-edit="{ form: item, key: 'nuit' }">{{ item.nuit }}</span>
                                    <span class="add-icon" v-edit="{ form: item, key: 'type' }">{{ item.type }}</span>
                                </div>
                                <div class="line"></div>
                            </div>
                            <p class="number-name font22" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 上上参谋已入驻服务商s -->
            <div class="in-show-box" v-img="{ form: form.secoundObj, key: 'img' }" :style="'background-image: url(' + form.secoundObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="boxTitleTips  wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.secoundObj, key: 'title' }">{{ form.secoundObj.title }}</p>
                        <p class="tips font24" v-edit="{ form: form.secoundObj, key: 'content' }">{{ form.secoundObj.content }}</p>
                    </div>
                    <div class="in-show-content">
                        <div class="in-show wow fadeInUp">
                            <div class="in-show-left">
                                <p class="in-show-name font26" v-edit="{ form: form.secoundObj, key: 'leftTitle' }">{{ form.secoundObj.leftTitle }}</p>
                                <!-- <div class="in-show-tips">
									<img src="../../assets/fuwu/notice.png" />
									<span class="font14">今日新增 80 人提交门店装修意向</span>
								</div> -->
                                <ul class="show-list">
                                    <li v-for="(item, key) in form.secoundObj.leftList" :key="key">
                                        <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                                        <p class="contentText font18" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="in-show-right">
                                <p class="name font26" v-edit="{ form: form.secoundObj, key: 'rightTitle' }">{{ form.secoundObj.rightTitle }}</p>
                                <el-carousel indicator-position="outside" arrow="never" :autoplay="false">
                                    <el-carousel-item v-for="(item, key) in form.secoundObj.list" :key="key">
                                        <itemAdd :list="form.secoundObj.list" :itemIndex="key"></itemAdd>
                                        <div class="carousel-img-content" style="position:relative">
                                            <div v-img="{ form: item, key: index }" v-for="(i, index) in item" :key="index">
                                                <itemAdd :list="item" :itemIndex="index"></itemAdd>
                                                <img :src="i" />
                                            </div>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                        <router-link to="" class="but join-but join-but-hover wow fadeInUp" type="primary">
                            <template v-edit="{ form: form.thiredObj, key: 'title' }">
                                {{ form.thiredObj.title }}
                            </template>
                            <div class="but-background"></div>
                            <p class="c-t font20" style="cursor:pointer" v-edit="{ form: form.thiredObj, key: 'content' }" @click="showToggle">{{ form.thiredObj.content }}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <!-- 上上参谋已入驻服务商e -->
            <!-- 想要了解更多信息或寻求商务合作s -->
            <div class="animateDom cooperation-box" v-img="{ form: form.fourthObj, key: 'img' }" :style="'background-image: url(' + form.fourthObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="cooperation-content">
                        <div class="cooperation-text cooperation-animate-module">
                            <p class="cooperation-text-title font36" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</p>
                            <p class="cooperation-text-tips font18" v-edit="{ form: form.fourthObj, key: 'content' }">{{ form.fourthObj.content }}</p>
                        </div>
                        <div class="contact-img">
                            <img src="../../assets/cloudHome/contact.png" />
                            <img v-img="{ form: form.fourthObj, key: 'contactCode' }" style="width:100px;height:100px" :src="form.fourthObj.contactCode" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 想要了解更多信息或寻求商务合作e -->
        </div>
        <submit-form :form="form" :refComponentId="160" :id="135"></submit-form>
        <guidance :show="show" @hiddenToggle="hiddenToggle"></guidance>
    </div>
</template>

<script>
import navBar from '../../components/superiorStaffNavBar.vue';
import { initWow } from '@/utils/wow';
import submitForm from '../../components/submit-form.vue';
import { pageQuery } from '../../api/index';
import Guidance from '@/components/guidance.vue';
import itemAdd from '../../components/item-add.vue';
export default {
    name: '',
    data() {
        return {
            show: false,
            carouselActive: 0,
            form: {
                // bannerObj:{
                // 	title:'加入上上参谋官方服务商',
                // 	content:'300万开店者都在用的数字化产品',
                // 	buttonContent:'了解详情',
                // 	path:'/',
                // 	img:require('../../assets/fuwu/banner_join.jpg')
                // },
                // firstObj:{
                // 	title:'海量开店用户聚集',
                // 	content:'百万用户的数字化开店平台',
                // 	list:[{
                // 		name:'300',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'开店者'
                // 	},{
                // 		name:'100',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'月活开店者'
                // 	},{
                // 		name:'50',
                // 		unit:'万',
                // 		type:'+',
                // 		content:'待转商铺'
                // 	},
                // 	{
                // 		name:'1000',
                // 		unit:'',
                // 		type:'+',
                // 		content:'优选品牌加盟'
                // 	}]
                // },
                // secoundObj:{
                // 	img:require('../../assets/fuwu/provider_bg.jpg'),
                // 	title:'上上参谋已入驻服务商',
                // 	content:"文字描述文字描述文字描述文字描述文字描述",
                // 	leftTitle:'热卖服务',
                // 	leftList:[{title:'门招外立面设计【标准版】',img:require('../../assets/fuwu/li1.png')},{title:'LOGO 设计【标准版】',img:require('../../assets/fuwu/li2.png')},{title:'海报设计【尊享版】',img:require('../../assets/fuwu/li3.png')}],
                // 	rightTitle:'已与我们达成合作的服务商',
                // 	list:[[require('../../assets/logo/fuwugai/logoico (1).png'),require('../../assets/logo/fuwugai/logoico (1).png'),require('../../assets/logo/fuwugai/logoico (1).png'),require('../../assets/logo/fuwugai/logoico (1).png'),require('../../assets/logo/fuwugai/logoico (1).png'),require('../../assets/logo/fuwugai/logoico (1).png')],[require('../../assets/logo/fuwugai/logoico (2).png')],[require('../../assets/logo/fuwugai/logoico (3).png')]]
                // },
                // thiredObj:{
                // 	title:'我是服务商，我要加入',
                // 	content:'我是服务商，我要加入'
                // },
                // fourthObj:{
                // 	img:require('../../assets/canmo/contact_blue_bg.jpg'),
                // 	title:'想要了解更多信息或寻求商务合作',
                // 	content:'您可以通过以下方式联系我们，我们将为您推荐满足需求的产品，或指派专业的销售顾问为您服务。'
                // }
            }
        };
    },
    mounted() {
        pageQuery({ componentId: '160', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
                $('.beatingNumber').each(function() {
                    var h = Number($(this).html());
                    var t = '';
                    var n = Math.ceil(h / 20);
                    var a = true;
                    var This = $(this);
                    if ($(this).length != 0) {
                        t = $(this).offset().top;
                    }
                    This.html(0);
                    fn1();
                    $(window).scroll(function() {
                        fn1();
                    });

                    function fn1() {
                        var wT = $(window).scrollTop();
                        if (wT > t - $(window).height() + 50 && wT < t - 50 && a == true) {
                            a = false;
                            var y = 0;
                            var timer2 = setInterval(function() {
                                if (y >= h) {
                                    y = h;
                                    clearInterval(timer2);
                                }
                                This.html(y);
                                y += n;
                            }, 100);
                        }
                    }
                });
            });
        });
    },
    computed: {},
    methods: {
        showToggle() {
            if (this.isAdmin) return;
            this.show = true;
        },
        hiddenToggle() {
            this.show = false;
        },
        jumpPage(target, way) {
            if (way == 'router') {
                this.$router.push({
                    name: target
                });
            } else if (way == 'a') {
                window.open(target, '_blank');
            }
        },
        carouselChange(index) {
            console.log(index);
            this.carouselActive = index;
        },
        // 轮播图切换至上一页
        prevClick(e) {
            this.$refs.carouselRef.prev();
            this.setClickAnimate(e, 'control-but', 'control-but-active');
        },
        // 轮播图切换至下一页
        nextClick(e) {
            this.$refs.carouselRef.next();
            this.setClickAnimate(e, 'control-but', 'control-but-active');
        },
        performFunction() {
            let idName = [];
            for (let i = 1; i < 5; i++) {
                idName.push('beatingNumber' + i);
            }
            idName.forEach(i => {
                this.numberBeating(i);
            });
        },
        numberBeating(targetIdName = 'beatingNumber') {
            let dom = $('#' + targetIdName);
            let height = dom.parent().height();
            let text = dom.attr('data-num');
            dom.css({
                height: height + 'px'
            });
            let num = text.replace(/[^0-9]/gi, ''); //提取数字
            let len = num.length;
            for (let i = 0; i < len; i++) {
                let html = `<div class='beatingNumber-cell'>`;
                for (let t = 0; t < 10; t++) {
                    html = html + `<p>${t}</p>`;
                }
                html = html + '</div>';
                dom.append(html);
            }
            setTimeout(() => {
                let childrenDom = dom.find('.beatingNumber-cell');
                let numArr = num.split('');
                numArr.forEach((i, index) => {
                    let el = childrenDom.eq(index);
                    let elHeight = el.find('p').height();
                    el.css({
                        transform: `translateY(-${elHeight * i}px)`
                    });
                });
            }, 500);
        }
    },
    components: { navBar, submitForm, Guidance, itemAdd },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
@media screen and (max-width: 1024px) {
    .service-box {
        .head-box {
            height: auto !important;
            background-color: #fff;
        }

        .content {
            .banner-box {
                .banner-box {
                    .text-content {
                        margin-left: 10px !important;
                    }
                }
            }

            .animateDom {
                .box-title {
                    padding: 0 10px;
                }

                .tips {
                    padding: 0 10px;
                }

                .button-box {
                    padding-left: 10px;
                }

                .tabs-title {
                    padding: 0 10px;
                }
            }

            .number-show-box {
                .number-show-content {
                    .number-show-cell {
                        .number {
                            padding: 0 !important;
                        }

                        .line {
                            display: none;
                        }
                    }
                }
            }

            .in-show-box {
                padding-top: 40px !important;

                .in-show-content {
                    .in-show {
                        width: 100% !important;

                        .in-show-left {
                            // padding: 52px 10px 55px 10px !important;

                            .show-list {
                                li {
                                    // width: 370px !important;
                                }
                            }
                        }

                        .in-show-right {
                            width: 100%;
                            box-sizing: border-box;
                            padding: 52px 10px 55px 10px !important;

                            .el-carousel {
                                width: 100% !important;

                                .el-carousel__container {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .join-but {
                        padding: 20px 30px;
                        @media @max-sm {
                            padding: 20px;
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1540px) {
    .service-box {
        .content {
            .banner-box {
                .text-box {
                    justify-content: flex-start !important;
                }
            }

            .tab-show-box {
                .tab-show-content {
                    overflow-x: auto;
                    overflow-y: hidden;
                }
            }
        }
    }
}

@-webkit-keyframes moduleUp {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }

    50% {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}

.service-box {
    width: 100%;
    position: relative;
    // letter-spacing: 1px;

    .but {
        background-color: #0081ff;
        padding: 16px 40px;
        font-size: 16px;
        border: none;
        border-radius: 35px;
        @media @max-xs {
            padding: 10px 15px;
        }
    }

    .but-blank {
        background: none;
        border: thin solid #fff;
    }

    .but-blank-hover:hover {
        background-color: #fff;
        color: #0082ff;
    }

    .join-but {
        border-radius: 6px;
        padding: 22px 100px;
        // font-size: 20px;
        margin: 70px 0 130px 0;
        position: relative;
        background: #0081ff;
        @media @max-sm {
            padding: 22px 50px;
            margin: 60px 0;
        }
        .but-background {
            width: 0%;
            height: 100%;
            background-color: #0269cf;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transition: all 0.5s;
            border-radius: 6px;
        }

        .c-t {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            color: #fff;
        }
    }

    .join-but-hover:hover {
        .but-background {
            width: 100%;
        }
    }

    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: rgba(255, 255, 255, 1);
    }

    .content {
        width: 100%;

        .banner-box {
            width: 100%;
            height: 600px;
            box-sizing: border-box;
            padding: 80px 0 0 0;
            background-repeat: no-repeat;
            // background: url('../../assets/fuwu/banner_join.jpg') no-repeat;
            background-size: cover;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            @media @max-xs {
                height: 100vw;
            }
            .text-content {
                text-align: center;
                // max-width: 565px;
                color: #fff;
                // display: flex;
                // flex-direction: column;
                // justify-content: center;
                // align-items: center;
                // margin-left: 60px;

                .tip-text {
                    margin-bottom: 72px;
                }
                .but {
                    transition: all 0.5s;
                    color: #fff;
                    &:hover {
                        background-color: #fff;
                        color: #0081ff;
                    }
                }
            }

            .text-box {
                width: 100%;
                height: 62px;
                position: absolute;
                bottom: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;

                .background {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    // flex-wrap: wrap;
                    justify-content: flex-start;
                    align-items: center;
                    align-content: flex-start;

                    .text {
                        height: 62px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-sizing: border-box;
                        margin-right: 1px;
                        padding: 0px 50px;
                        color: #fff;
                        flex-shrink: 0;
                        background-color: rgba(255, 255, 255, 0.3);

                        .title {
                            font-size: 16px;
                            font-family: 'PingFang-Heavy' !important;
                        }

                        .round {
                            width: 6px;
                            height: 6px;
                            border-radius: 100%;
                            background-color: #ffff;
                            margin-right: 10px;
                        }
                    }

                    // .text:hover {
                    // 	background-color: rgba(255, 255, 255, 0.7);
                    // }

                    .activeText {
                        background-color: rgba(255, 255, 255, 0.7);
                    }
                }
            }
        }

        .number-show-box {
            width: 100%;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 110px 0 100px 0;
            @media @max-xs {
                padding: 60px 0;
            }
            .box-title {
                color: #000;
                // font-size: 40px;
                margin-bottom: 15px;
                text-align: center;
            }

            .tips {
                text-align: center;
                color: #333;
                // font-size: 24px;
                margin-bottom: 35px;
                @media @max-xs {
                    margin-bottom: 0;
                }
            }

            .number-show-content {
                display: flex;
                flex-wrap: wrap;
                // justify-content: center;
                // align-items: center;

                .number-show-cell {
                    width: 25%;
                    box-sizing: border-box;
                    background: url('../../assets/fuwu/num_bg.png') no-repeat;
                    background-size: 237px 168px;
                    background-position: 55px center;
                    @media @max-md {
                        width: 50%;
                        margin-top: 40px;
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 1px;
                        height: 100%;
                        background-color: #9acfff;
                    }
                    &:nth-child(even) {
                        &::before {
                            display: none;
                        }
                    }
                    &:last-child {
                        &::before {
                            display: none;
                        }
                    }

                    .text-line {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .number {
                            width: 100%;
                            // height: 120px;
                            box-sizing: border-box;
                            box-sizing: border-box;
                            font-size: 80px;
                            line-height: 112px;
                            text-align: center;
                            // padding: 0 60px;
                            color: #0081ff;
                            font-family: 'PingFang-Heavy';
                            @media @max-lg {
                                font-size: 60px;
                                line-height: 80px;
                            }
                            @media @max-md {
                                font-size: 50px;
                                line-height: 70px;
                            }
                            @media @max-xs {
                                font-size: 35px;
                                line-height: 50px;
                            }
                            .unit {
                                font-size: 70px !important;
                                transform: translateY(4px);
                                @media @max-lg {
                                    font-size: 50px !important;
                                }
                                @media @max-md {
                                    font-size: 40px !important;
                                }
                                @media @max-xs {
                                    transform: translateY(0px);
                                    font-size: 30px !important;
                                }
                            }

                            .add-icon {
                                font-size: 55px;
                                @media @max-sm {
                                    font-size: 24px;
                                }
                            }
                        }
                    }

                    .number-name {
                        width: 100%;
                        text-align: center;
                        // font-size: 22px;
                        color: #999999;
                    }
                }
            }
        }

        .carousel-show-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #f7f9fa;
            background-image: url('../../assets/fuwu/case_icon_bg.png');
            background-repeat: no-repeat;
            background-size: 625px 505px;
            background-position: left top;
            padding-top: 120px;

            .box-title {
                color: #000;
                font-size: 40px;
                margin-bottom: 15px;
            }

            .tips {
                color: #5a6779;
                font-size: 24px;
                margin-bottom: 55px;
            }

            .carousel-show-content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding-bottom: 115px;
                position: relative;

                ::v-deep {
                    .el-carousel {
                        width: 1300px;

                        .el-carousel__container {
                            height: 600px;
                            border-radius: 8px;
                            background: none;
                        }
                    }
                }

                .control-but {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: calc(50% - 86px);
                }

                .control-but-active {
                    background-color: #0082ff;
                    color: #fff !important;
                    border: none;
                }

                .control-but:hover {
                    background-color: #0082ff;
                    color: #fff !important;
                    border: none;
                }

                .button-left {
                    left: -100px;
                }
                .button-right {
                    right: -100px;
                }

                .carousel-content {
                    width: 100%;
                    height: 100%;
                    padding: 35px 0px;
                    border-radius: 8px;
                    box-sizing: border-box;

                    .carousel-item-box {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .content-left {
                            width: calc(100% - 520px);
                            height: 100%;

                            .head-tabs {
                                width: 100%;
                                height: 60px;
                                display: flex;
                                align-items: flex-start;
                                overflow-x: auto;
                                overflow-y: hidden;

                                .carousel-tab {
                                    width: 130px;
                                    box-sizing: border-box;
                                    padding-right: 5px;
                                    font-size: 24px;
                                    color: #999999;
                                }

                                .tab-active {
                                    color: #121826 !important;
                                }
                            }

                            .textContent {
                                height: calc(100% - 70px);
                                box-sizing: border-box;
                                background-color: #fff;
                                padding: 0 0 20px 42px;
                                border-radius: 8px 0 0 8px;

                                .logo-text {
                                    height: 115px;
                                    box-sizing: border-box;
                                    padding: 0 50px 0 0;
                                    display: flex;
                                    flex-wrap: wrap;
                                    justify-content: space-between;
                                    align-items: center;
                                    border-bottom: thin solid #f4f7fa;
                                    background: url('../../assets/fuwu/case_icon_s_bg.png') no-repeat;
                                    background-size: 390px 183px;
                                    background-position: 460px top;

                                    .logoText {
                                        display: flex;
                                        align-items: center;

                                        .logoImg {
                                            width: auto;
                                            height: 65px;
                                            object-fit: scale-down;
                                        }

                                        .logoName {
                                            font-size: 24px;
                                            color: #333333;
                                            margin-left: 10px;
                                        }
                                    }

                                    .text {
                                        font-size: 14px;
                                        color: #666666;
                                    }
                                }

                                .text-content-div {
                                    height: 100px;
                                    overflow-y: auto;
                                    overflow-x: hidden;
                                    font-size: 16px;
                                    color: #65697f;
                                    margin-top: 30px;
                                }

                                .number-show-div {
                                    display: flex;
                                    align-items: center;

                                    .number-show-cell {
                                        width: 160px;
                                        box-sizing: border-box;
                                        color: #fff;

                                        .text-line {
                                            width: 100%;
                                            display: flex;
                                            justify-content: flex-start;
                                            align-items: baseline;
                                            color: #0081ff;
                                            font-size: 30px;

                                            .number {
                                                box-sizing: border-box;
                                                font-size: 55px;
                                                text-align: center;
                                                font-family: 'PingFang-Heavy' !important;
                                            }
                                        }

                                        .number-name {
                                            width: 100%;
                                            text-align: left;
                                            font-size: 16px;
                                            color: #999999;
                                            text-indent: 6px;
                                            transform: translateY(-12px);
                                        }
                                    }

                                    .line {
                                        width: 2px;
                                        height: 40px;
                                        background-color: #e6e6e6;
                                        margin-right: 28px;
                                    }
                                }
                            }
                        }

                        .r-img {
                            height: 100%;

                            img {
                                width: 520px;
                                height: 520px;
                            }
                        }
                    }
                }
            }
        }

        .in-show-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            // background-image: url('../../assets/fuwu/provider_bg.jpg');
            background-repeat: no-repeat;
            background-size: 100% 300px;
            padding-top: 60px;
            animation-play-state: paused;
            opacity: 1 !important;
            transform: translateY(0) !important;

            .box-title {
                color: #fff;
                // font-size: 40px;
                margin-bottom: 4px;
            }

            .tips {
                color: #fff;
                // font-size: 24px;
                margin-bottom: 60px;
            }

            .in-show-content {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .in-show {
                    // width: 1400px;
                    width: 100%;
                    background-color: #fff;
                    border-radius: 8px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    box-shadow: 0 0px 16px 0 rgba(204, 204, 204, 0.4);

                    .in-show-left {
                        width: 33%;
                        box-sizing: border-box;
                        padding: 52px 2.8% 55px 2.8%;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: space-between;
                        background-color: #f4f8ff;
                        border-radius: 8px 0 0 8px;
                        @media @max-md {
                            padding: 60px 30px;
                            border-radius: 8px 8px 0 0;
                            width: 100%;
                        }
                        .in-show-name {
                            // font-size: 25px;
                            color: #333333;
                        }

                        .in-show-tips {
                            // font-size: 14px;
                            color: #65697f;
                            display: flex;
                            align-items: center;

                            img {
                                width: 17px;
                                height: 17px;
                                margin-right: 9px;
                            }
                        }

                        .show-list {
                            margin-top: 26px;
                            width: 100%;
                            li {
                                width: 100%;
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                background-color: #ffffff;
                                padding: 15px;
                                box-sizing: border-box;
                                margin-bottom: 10px;
                                border-radius: 8px;

                                img {
                                    width: 70px;
                                    height: 70px;
                                    object-fit: scale-down;
                                    margin-right: 25px;
                                    @media @max-xs {
                                        width: 40px;
                                        height: 40px;
                                        margin-right: 10px;
                                    }
                                }

                                .contentText {
                                    width: calc(100% - 95px);
                                    // font-size: 18px;
                                    color: #333333;
                                    @media @max-xs {
                                        width: calc(100% - 50px);
                                    }
                                }
                            }
                            li:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .in-show-right {
                        width: 67%;
                        padding: 52px 2.7% 46px 2.7%;
                        box-sizing: border-box;
                        @media @max-md {
                            width: 100%;
                            padding: 60px 30px;
                        }
                        .name {
                            text-indent: 0.6em;
                            // font-size: 25px;
                            color: #333;
                            margin-bottom: 45px;
                            font-family: 'PingFang-Heavy' !important;
                        }

                        ::v-deep {
                            .el-carousel {
                                width: 100%;

                                .el-carousel__container {
                                    width: 100%;
                                    height: 290px;
                                    border-radius: 8px;
                                    background: none;
                                    @media @max-lg {
                                        height: 270px;
                                    }
                                    @media @max-xs {
                                        height: 200px;
                                    }
                                    .el-carousel__item {
                                        height: 100%;
                                    }
                                }

                                .el-carousel__indicators {
                                    text-align: left;
                                    text-indent: 2em;

                                    .is-active {
                                        button {
                                            width: 40px;
                                            background-color: #0081ff;
                                        }
                                    }
                                }
                            }
                        }

                        .carousel-img-content {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            align-content: flex-start;
                            overflow-y: auto;
                            overflow-x: hidden;

                            img {
                                // width: 215px;
                                // height: 124px;
                                display: block;
                                width: 150px;
                                height: 75px;
                                object-fit: contain;
                                margin-right: 20px;
                                margin-bottom: 20px;
                                box-shadow: -1px 2px 21px 0 rgba(142, 173, 255, 0.13);
                                &:nth-child(5n) {
                                    margin-right: 0;
                                }
                                @media @max-lg {
                                    width: 120px;
                                    height: 60px;
                                }
                                @media @max-md {
                                    width: 150px;
                                    height: 75px;
                                }
                                @media @max-xs {
                                    width: 90px;
                                    height: 45px;
                                    margin-right: 10px;
                                }
                                // height: auto;
                                object-fit: scale-down;
                            }
                        }
                    }
                }
            }
        }

        .cooperation-box {
            width: 100%;
            height: auto;
            // background: url('../../assets/fuwu/provider_bg.jpg') no-repeat;
            background-repeat: no-repeat;
            background-size: cover;
            padding-top: 28px;
            animation-play-state: paused;
            opacity: 1 !important;
            transform: translateY(0) !important;
            @media @max-sm {
                padding-top: 60px;
            }
            .cooperation-content {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                align-content: flex-start;

                .cooperation-text {
                    max-width: 550px;
                    color: #fff;
                    padding-left: 10px;
                    letter-spacing: 0;
                    @media @max-md {
                        max-width: 450px;
                    }
                    @media @max-sm {
                        max-width: 100%;
                        width: 100%;
                        text-align: center;
                        padding-left: 0;
                    }
                    .cooperation-text-title {
                        // font-size: 35px;
                        margin-bottom: 4px;
                        font-family: 'PingFang-Heavy' !important;
                        // transform: translateY(-14px);
                    }
                }

                .contact-img {
                    position: relative;
                    margin-right: 120px;

                    @media @max-md {
                        margin-right: 60px;
                    }
                    @media @max-sm {
                        margin-top: 60px;
                        margin-right: 0;
                        margin: 60px auto 0;
                    }
                    img {
                        width: 260px;
                        height: auto;
                        object-fit: scale-down;
                        &:nth-child(2) {
                            position: absolute;
                            left: 82px;
                            width: 100px;
                            top: 84px;
                        }
                    }
                }
            }
        }
    }
}
</style>
